import React, { useState } from "react";
import { Box, Grid, CircularProgress } from "@mui/material";
import RiskScoreFilter from "./riskScoreFIlter";
import RiskGaugeChart from "./riskGaugeChart";
import CodingDetails from "./codingDetaill";
import ScoreSummary from "./scroeSummary";
import DiagnosisSummary from "./diagDetails";

const RiskScore = () => {
  const [data, setData] = useState();
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  if (loading) {
    return (
      <Box
        padding={4}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box p={2} maxWidth="lg" mx="auto">
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} md={8}>
            <RiskScoreFilter
              setLoading={setLoading}
              open={open}
              setData={setData}
              setOpen={setOpen}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            {data && <RiskGaugeChart value={data.score ?? 0} />}
          </Grid>
        </Grid>
      </Box>

      <Box p={2} maxWidth="lg" mx="auto">
        {data?.category_details && (
          <CodingDetails category_details={data?.category_details} />
        )}
        {data && <ScoreSummary data={data} />}
        {data?.diag_code_details && data?.diag_code_details.length > 0 && (
          <DiagnosisSummary diag_code_details={data.diag_code_details} />
        )}
      </Box>
    </>
  );
};

export default RiskScore;
